import React from "react";
import { connect } from "react-redux";
import {
  SearchModes,
  updateAlternatePage, updateResults
} from "../../store/actions";
import Pagination from "./Pagination";
import StickyTable from "./StickyTable";

function createMarkup(markup) {
  return {__html: markup};
}

class AlternativeResults extends React.Component {

  render() {
    const { alternativeResults, activeSearchMode } = this.props;
    const shouldRender = !!(alternativeResults.length > 0 && activeSearchMode === SearchModes.ALTERNATIVE);
    return shouldRender && (
      <>
      {/* <div ref={window.drupalSettings.productfinder.alternativeRef} dangerouslySetInnerHTML={createMarkup(alternativeResults)} /> */}
      <div ref={ProductFinder.alternativeRef} dangerouslySetInnerHTML={createMarkup(alternativeResults)} />
      <div className="pagination-bottom">
      <Pagination
        pages={this.props.pages}
        page={this.props.page}
        count={this.props.count}
        defaultPageSize={12}
        ofText="of"
        previousText="Previous"
        nextText="Next"
        onPageChange={(pageIndex) => {
          this.props.updateAlternatePage(pageIndex);
          this.props.updateResults(true);
        }}
      />
      </div>
      </>
    );
  }
}


const mapStateToProps = (state) => {
  const pageSize = state.results.countAlternative - state.parameters.alternateSearchPage*12;
  return {
    activeSearchMode: state.parameters.activeSearchMode,
    alternativeResults: state.results.resultAlternative,
    count: state.results.countAlternative ? state.results.countAlternative : 0,
    pages: Math.ceil(state.results.countAlternative/12),
    page: state.parameters.alternateSearchPage,
    pageSize: ((pageSize < 20) ? pageSize : 20),
  }
};

export default connect(
  mapStateToProps,
  {updateAlternatePage, updateResults }
)(AlternativeResults)
